var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-input",
    _vm._b(
      {
        attrs: { type: "number", value: _vm.displayValue },
        on: { input: _vm.handleInput }
      },
      "q-input",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }